import { Box, Stack } from '@mui/material'

import RationsFullCards from 'components/rationSystem/RationsFullCards'
import RationsFullComponents from 'components/rationSystem/RationsFullComponents'
import { useTabsController } from 'hooks/useTabsController'
import PageContainer from 'layouts/PageContainer'
import { COLORS } from 'styles/colors'
import TabsFilter from 'ui/breadCrumbs/TabsFilter'

const LIST_OPTIONS = [
	{
		key: 'ration',
		title: 'Рационы',
	},
	{
		key: 'components',
		title: 'Компоненты',
	},
]

type RationListTab = 'ration' | 'components'

const RationPageEntry = () => {
	const { tab, changeTab } = useTabsController<RationListTab>({
		keyName: 'tab',
		defaultValue: 'ration',
	})
	const activeList: RationListTab =
		tab === 'components' ? 'components' : 'ration'

	return (
		<PageContainer>
			<Stack>
				<Box
					sx={{
						position: 'sticky',
						top: 0,
						backgroundColor: COLORS.background,
						zIndex: 90,
					}}
				>
					<TabsFilter
						onClick={id => {
							if (id === 'ration' || id === 'components') {
								changeTab(id)
							}
						}}
						availableTabs={LIST_OPTIONS}
						selectedKey={activeList}
					/>
				</Box>
				<Box sx={{ marginTop: '16px' }}>
					{activeList === 'ration' ? (
						<RationsFullCards />
					) : (
						<RationsFullComponents />
					)}
				</Box>
			</Stack>
		</PageContainer>
	)
}

export { RationPageEntry }
